(function() {
  function initAccordion() {
    document.addEventListener('click', (e) => {
      const questionBtn = e.target.closest('.faq-question');
      if (!questionBtn) return;
      
      const item = questionBtn.closest('.faq-item');
      if (!item) return;

      const isActive = item.classList.contains('active');
      const container = item.closest('.faq-list') || item.parentElement;

      // Close siblings in the same container
      if (container) {
        const siblings = container.querySelectorAll('.faq-item');
        siblings.forEach(i => i.classList.remove('active'));
      }

      if (!isActive) {
        item.classList.add('active');
      }
    });
  }

  // Use event delegation on document to handle dynamic content
  initAccordion();
})();
